<template>
  <div
    class="TNovoGrupo"
    data-testid="TNovoGrupo"
  >
    <div class="TNovoGrupo__Header">
      <slot name="titulo" />
    </div>

    <div class="TNovoGrupo__Main">
      <slot name="campos" />
    </div>
    <div class="TNovoGrupo__Centro">
      <slot name="centro" />
    </div>
    <div class="TNovoGrupo__Footer">
      <slot name="acoes" />
    </div>
    <div class="TNovoGrupo__Modais">
      <slot name="modais" />
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
  @import "./TNovoGrupo.style.scss";
</style>
